export default __webpack_public_path__ + "static/N0168-73ba6ce3e0a6f43f65c77ce76cba7440.png";